import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import useOutsideClick from "@/hooks/useOutsideClick";
import { isMobileDevice } from "@/libs/utils";
import CloseIcon from "../Icon/CloseIcon";
import PaPaySetUpIcon from "../Icon/PaPaySetUpIcon";
import CheckIcon from "../Icon/CheckIcon";
import ExclamationIcon from "../Icon/ExclamationIcon";

type Props = {
  isInfoModal: Boolean;
  setIsInfoModal: Function;
};

const VerificationInfoModal = ({ isInfoModal, setIsInfoModal }: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  useOutsideClick(modalRef, isInfoModal, setIsInfoModal);

  const headStyles = { fontSize: "18px", fontStyle: "normal", fontWeight: 700 };

  return (
    <div className="bg-[#2626267D] fixed top-0 left-0 w-full h-screen justify-center items-center overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none">
      <div
        className={` mx-auto opacity-100 bg-white text-[#333] border-1 border-2-gray-400 shadow-md rounded-xl py-4 mt-10 ${
          isMobileDevice() ? "bottom-0 w-full mx-none fixed" : "xs:w-[390px]"
        }`}
        ref={modalRef}
      >
        <div className="flex justify-between items-center text-xl font-semibold text-center py-3 px-8">
          <Image width={134} height={24} src="/assets/logo.svg" alt="logo" />
          <CloseIcon
            fill="#818181"
            className="cursor-pointer"
            onClick={() => {
              setIsInfoModal(false);
              document.body.style.overflowY = "scroll";
            }}
          />
        </div>
        <div className="px-9">
          <div style={{ fontSize: 24, fontWeight: "700" }} className="pt-2">
            Gain trust with verification
          </div>
          <div className="py-3">
            PrivateAuto brings trust and transparency to the private sale. You
            decide who to work with based on verification.
          </div>
          <div className="flex" style={headStyles}>
            <PaPaySetUpIcon size={36} />
            <div className="p-1 px-2">Full verification</div>
          </div>
          <ul
            style={{ listStyleType: "disc", marginLeft: "52px" }}
            className="py-2"
          >
            <li>PrivateAuto Pay active</li>
            <li>Can send and receive money</li>
            <li>Background check / KYC</li>
            <li>Verified SSN</li>
            <li>Verified driver's license</li>
            <li>Facial recognition</li>
          </ul>

          <div className="flex" style={headStyles}>
            <CheckIcon size={36} />
            <div className="p-1 px-2">Partial verification</div>
          </div>
          <ul
            style={{ listStyleType: "disc", marginLeft: "52px" }}
            className="py-2"
          >
            <li>Phone verified with ownership check</li>
            <li>Digital identity verified / KYC</li>
            <li>DOB + address verified</li>
            <li>Email verified</li>
          </ul>

          <div className="flex" style={headStyles}>
            <ExclamationIcon size={36} />
            <div className="p-1 px-2">Not verified</div>
          </div>
          <ul
            style={{ listStyleType: "disc", marginLeft: "52px" }}
            className="py-2"
          >
            <li>The person hasn’t verified their account yet.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VerificationInfoModal;
